import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import GalleryService, {
  ICreateGalleryParams,
} from '@clickersphere/core/services/GalleryService';
import useToast from '../useToast';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { GALLERIES_QUERY_KEY, GalleryQueryData } from './useGalleries';

export function useCreateGallery() {
  const queryClient = useQueryClient();
  const { buildQueryKey } = useBuildQueryKey();
  const { toast } = useToast();
  const { t } = useTranslation();

  const { isPending: createGalleryIsPending, mutateAsync: createGalleryAsync } =
    useMutation({
      mutationFn: async (data: ICreateGalleryParams) => {
        const gallery = await GalleryService.create(data);
        return gallery as GalleryQueryData;
      },
      onSuccess: (data) => {
        queryClient.setQueryData<GalleryQueryData[]>(
          buildQueryKey([GALLERIES_QUERY_KEY, data.leadId]),
          (old) => [...(old ?? []), data],
        );
        toast(t('gallery.toasts.created'), 'success');
      },
      onError: () => {
        toast(t('gallery.toasts.createError'), 'error');
      },
    });

  return {
    createGalleryAsync,
    createGalleryIsPending,
  };
}
